    <div class="toggle" (click)="click()" [ngClass]="{on:visible,off:!visible}" >
        <ico [ico]="ico" [rotate]="visible?angle[1]:angle[0]"></ico>
    </div>
